import { UserLimiter } from './user-limiter';
import { ClientDetails } from '../../clients/models/client-details';
import { ClientParent } from '../../client-parents/models/client-parent';

export class User {
    
  constructor(public id: number = null,
              public mciUserId: number = null,
              public name: string = null,
              public email: string = null,
              public active: boolean = false,
              public role: string = null,
              public roleId: string = null,
              public limitedBy: UserLimiter = new UserLimiter(),
              public limitedByString: string = null,
              public clientRef: number = null,
              public clientParentRef: number = null,
              public selectedClient: ClientDetails = null,
              public selectedClientParent: ClientParent = null,

              public createdDate: Date = null,
              public emailConfirmed: boolean = false,
              public emailConfirmedDate: Date = null,
              public status: string = null,
              public activeDate: Date = null,
              public disabledDate: Date = null,
              public invitedDate: Date = null,
              public salutationName: string = null) {
  }
}
